// extracted by mini-css-extract-plugin
export default {"labelButton":"LabelButton_labelButton__rY5Vu"};